import { gql } from "apollo-boost";

const SERVER_GET_COMPANIES = gql`
  query SERVER_Companies {
    companies {
      ...companyGeneralInfo
      address {
        ...addressGeneralInfo
        __typename
      }
      __typename
    }
    dashboard {
      onlineUsers {
        id
        firstname
        lastname
        initials
        email
        company {
          id
          __typename
        }
        fullname
        avatar {
          id
          hashName
          name
          ext
          mime
          url
          __typename
        }
        __typename
      }
      totalUsers
      totalOnline
      __typename
    }
  }

  fragment addressGeneralInfo on Address {
    address
    postalCode
    commune
    city
    province
    region
    country
    __typename
  }

  fragment companyGeneralInfo on Company {
    id
    name
    description
    slug
    phone
    url
    email
    status
    logo {
      ...uploadFileGeneralInfo
      __typename
    }
    loginBackground {
      ...uploadFileGeneralInfo
      __typename
    }
    __typename
  }

  fragment uploadFileGeneralInfo on UploadFile {
    id
    url
    hashName
    name
    mime
    ext
    createdAt
    updatedAt
    __typename
  }
`;

export default SERVER_GET_COMPANIES;
